export default class ScrollIndicator {
	private target: HTMLElement;
	private tempPosition: number;

	public constructor(target: HTMLElement) {
		this.target = target;
		this.tempPosition = 0;

		this.handle = this.handle.bind(this);

		document.addEventListener('scroll', this.handle, { passive: true });
		document.addEventListener('touchmove', this.handle, { passive: true });

		this.handle();
	}

	private handle(): void {
		const position = document.documentElement.scrollTop;

		switch (true) {
			case position === 0:
				this.onTop();
				break;
			case position < this.tempPosition:
				this.scrollUp();
				break;
			case position > this.tempPosition:
				this.scrollDown();
				break;
		}

		this.tempPosition = position;
	}

	private onTop(): void {
		this.target.classList.remove('window--scroll-down');
		this.target.classList.remove('window--scroll-up');
		this.target.classList.add('window--on-top');
	}

	private scrollDown(): void {
		this.target.classList.remove('window--on-top');
		this.target.classList.remove('window--scroll-up');
		this.target.classList.add('window--scroll-down');
	}

	private scrollUp(): void {
		this.target.classList.remove('window--on-top');
		this.target.classList.remove('window--scroll-down');
		this.target.classList.add('window--scroll-up');
	}
}
